import React, { useMemo } from 'react';
import { Category } from '@graphql/generated';
import { pxToRem } from '@withjoy/joykit/theme';
import type { RichTextEditorOverrideProps } from '@withjoy/joykit/components/RichTextEditor/RichTextEditor.styles';
import { RichTextEditorGlobalStyle } from '@withjoy/joykit/components/RichTextEditor/RichTextEditor.styles';
import { RichTextGlobalStyle } from './RichText.styles';
import { useScaleGuestSiteFontSize } from '@shared/core/website/theming/useScaleGuestSiteFontSize';
import { OverrideTypography } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.types';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';

const typographyOverride: OverrideTypography = [
  { variant: 'display4', category: Category.HEADING },
  { variant: 'body4', category: Category.PARAGRAPH },
];

export const RichTextStylesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { scaleFontSize } = useScaleGuestSiteFontSize();

  const overrides: RichTextEditorOverrideProps = useMemo(
    () => ({
      Paragraph: { props: { typographyVariant: 'body4' } },
      Heading: {
        h1: { props: { fontSize: scaleFontSize(pxToRem(32), Category.HEADING) } },
        h2: { props: { fontSize: scaleFontSize(pxToRem(24), Category.HEADING) } },
        h3: { props: { fontSize: scaleFontSize(pxToRem(18.72), Category.HEADING) } },
        h4: { props: { fontSize: scaleFontSize(pxToRem(16), Category.HEADING) } },
        h5: { props: { fontSize: scaleFontSize(pxToRem(13.28), Category.HEADING) } },
        h6: { props: { fontSize: scaleFontSize(pxToRem(10.72), Category.HEADING) } },
      },
    }),
    [scaleFontSize],
  );

  return (
    <>
      <GuestSiteTypographyOverride override={typographyOverride}>
        <RichTextGlobalStyle />
        <RichTextEditorGlobalStyle overrides={overrides} />
      </GuestSiteTypographyOverride>
      {children}
    </>
  );
};
